import { useContext } from "react";
import { UIContext } from "../contexts/UIContext";

export const useUI = () => {
  const context = useContext(UIContext);
  if (!context) {
    throw new Error("useUI debe usarse dentro de un UIProvider");
  }
  return context;
};
